import React from "react";
import { Select } from "components";
import { useExemptionsContext } from "../../ExemptionsContext";
import { useEventTracker } from "utils/useEventTracker";
import constants from "utils/constants";
import { usePropertyContext } from "../../context";
import ButtonV2 from "elements/ButtonV2";

const AlreadyFiled = () => {
	const { next, specialFieldsValue, setSpecialFieldsValue } =
		useExemptionsContext();
	const { details } = usePropertyContext();
	const trackEvent = useEventTracker();

	const handleSubmit = async () => {
		trackEvent({
			eventName: constants.EVENTS.Exemptions_Flow_Already_Filed_Answer,
			data: {
				"Already Filed": specialFieldsValue?.already_filed,
				"Is End-To-End Signup": details?.exemption?.is_end_to_end_signup
					? "Yes"
					: "No",
			},
		});
		const trackingEventData = {
			"Already Filed": specialFieldsValue?.already_filed,
		};
		next({ trackingEventData });
	};

	const warningMessage = React.useMemo(() => {
		if (specialFieldsValue?.already_filed === true) {
			return "To avoid potential conflicts, we will not proceed to file your exemption application at this time. If you still want Ownwell to file and manage the process for you, you can change your answer to No and proceed. Otherwise, click Continue and we will look for other ways to save you money.";
		}

		return null;
	}, [specialFieldsValue?.already_filed]);

	const infoMessage = React.useMemo(() => {
		if (specialFieldsValue?.already_filed === false) {
			return "Great! We’ll create your application including all supporting files and documents, file directly with the county and manage the process end to end for you to help maximize your savings potential.";
		}

		return null;
	}, [specialFieldsValue?.already_filed]);

	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				handleSubmit();
			}}>
			<div className="property-profile-question-card exemption-survey-card">
				<div className="property-profile-question-card-title-container">
					<p>
						Have you already filed an exemption application for{" "}
						{details?.address}?
					</p>
				</div>
				<p className="exemption-question-card-subtitle sm">
					We can work directly with the county to ensure your exemption
					paperwork is processed and applied correctly to your next tax bill.
				</p>
				<Select
					containerClassName="exemptions-card-input"
					value={
						specialFieldsValue?.already_filed === undefined
							? ""
							: specialFieldsValue.already_filed === true
								? "Yes"
								: "No"
					}
					onChange={e =>
						setSpecialFieldsValue({
							already_filed: e.target.value === "Yes",
						})
					}>
					<option value="" hidden disabled>
						Select an Answer
					</option>
					<option value="Yes">Yes, it has already been filed</option>
					<option value="No">No, I want Ownwell to file it</option>
				</Select>
			</div>
			{warningMessage && (
				<p className="sm exemptions-notification-message-rust mt-4">
					To avoid potential conflicts, we will not proceed to file your
					exemption application at this time. If you still want Ownwell to file
					and manage the process for you, you can change your answer to No and
					proceed. Otherwise, click Continue and we will look for other ways to
					save you money.
				</p>
			)}
			{infoMessage && (
				<p className="sm exemptions-notification-message-azure mt-4">
					Great! We’ll create your application including all supporting files
					and documents, file directly with the county and manage the process
					end to end for you to help maximize your savings potential.
				</p>
			)}
			<ButtonV2
				size="large"
				disabled={specialFieldsValue?.already_filed === undefined}
				type="submit">
				Continue
			</ButtonV2>
		</form>
	);
};

export default AlreadyFiled;
